import src from "IMAGE";
export default { src, width: 1702, height: 410, blurWidth: 0, blurHeight: 0};
